import { tenantApi } from "@/modules/tenant/services/tenantApi";
import type { AssetWritePayload, MarkAssetSoldPayload } from "./engineApi";
import type { Trailer } from "../types/trailer.types";
import type { ProvenanceMap } from "../types/boat.types";

export const trailerApi = {
  getTrailers: (params: {
    page?: number;
    per_page?: number;
    search?: string;
    condition?: string | string[];
    manufacturer?: string | string[];
    status_id?: string | string[];
    location_id?: string | string[];
    attachment?: "loose" | "attached";
    sort_by?: string;
    sort_order?: string;
  }) => tenantApi.getPaginated<Trailer>("/trailers", { params }),

  // Single trailer + tagged-boat history.
  getTrailer: (id: string) => tenantApi.getOne<Trailer>(`/trailers/${id}`),

  // SP3-full slice 3 — the asset provenance projection (flat form keys; the
  // canvas hydrates its 4-state tints from this on resume + after a merge).
  getFieldSources: (id: string) =>
    tenantApi.getOne<ProvenanceMap>(`/trailers/${id}/field-sources`),

  // SP2-D — manual CRUD.
  createTrailer: (data: AssetWritePayload) => tenantApi.postOne<Trailer>("/trailers", data),
  updateTrailer: (id: string, data: AssetWritePayload) => tenantApi.putOne<Trailer>(`/trailers/${id}`, data),
  deleteTrailer: (id: string) => tenantApi.deleteOne(`/trailers/${id}`),

  // SP4 slice 1 — mark-sold lifecycle. 422s with errors.active_link while the
  // trailer is attached to a boat (D2: detach first).
  markSold: (id: string, data: MarkAssetSoldPayload) =>
    tenantApi.postOne<Trailer>(`/trailers/${id}/mark-sold`, data),
};
